export interface ListedAssetType {
  id: string;
  name: string;
  assetClass: AssetClass;
  fieldCount: number;
}

export const assetClasses = [
  'STANDALONE_EQUIPMENT',
  'EQUIPMENT_GROUP',
] as const;
export type AssetClass = (typeof assetClasses)[number];

export type AssetTypeFieldType =
  | 'TEXT'
  | 'BOOLEAN'
  | 'INTEGER'
  | 'REAL'
  | 'DATE'
  | 'TIMESTAMP'
  | 'ENUM';

export interface AssetTypeInput {
  name: string;
  assetClass: AssetClass;
  fields: AssetTypeField[];
  compatibleActionTypes: string[];
}

export interface AssetTypeField {
  name: string;
  type: AssetTypeFieldType;
  required: boolean;
  enumChoices?: string[];
  /** Only on INTEGER and REAL fields. */
  unit?: string | null;
  /**
   * Inclusive, as text like field values: `,` is accepted as the decimal point, and `.` comes back. Only on
   * INTEGER and REAL fields, and a whole number on INTEGER ones.
   */
  min?: string | null;
  /** Inclusive; same as `min`. */
  max?: string | null;
  description?: string | null;
}

export interface AssetType extends AssetTypeInput {
  id: string;
  fullyEditable: boolean;
}
